import { ContentTableItem } from "src/components/ContentTable/ContentTable";

export function mapFavouritesToContentTableItems(
	favourites: AdminHashtag[]
): ContentTableItem[] {
	return [...favourites]
		.sort((a, b) => {
			const aOrder = Number.isFinite(a.favouriteOrdering)
				? a.favouriteOrdering
				: Infinity;
			const bOrder = Number.isFinite(b.favouriteOrdering)
				? b.favouriteOrdering
				: Infinity;
			return aOrder - bOrder || a.uuid.localeCompare(b.uuid);
		})
		.map((hashtag, index) => ({
			id: hashtag.uuid,
			name: hashtag.name,
			isActive: true,
			order: index + 1
		}));
}
